import React, { PropsWithChildren } from 'react';

type ProfileTabProps = {
  id: string;
  onSelected: (tabId: string) => void;
  selected: boolean;
  tabId?: string;
  controls?: string;
};

const ProfileTab: React.FC<PropsWithChildren<ProfileTabProps>> = ({
  children,
  id,
  selected,
  onSelected,
  tabId,
  controls,
}) => {
  return (
    <button
      type="button"
      role="tab"
      id={tabId}
      aria-selected={selected}
      aria-controls={controls}
      onClick={() => onSelected(id)}
      className={`${
        selected ? 'font-bold shadow-selectedBottomDivider' : 'text-grey'
      } heading-20 pb-2 pt-1 mr-2 border-none bg-transparent cursor-pointer`}
    >
      {children}
    </button>
  );
};

export default ProfileTab;
